import { Box, Typography } from "@mui/material"

export const ViewConfigTable = ({
  columns,
  mapper,
  data,
}: {
  columns: string[]
  mapper: string[]
  data: any
}) => {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          gap: "10px",
          gridAutoFlow: "column",
        }}
      >
        {mapper.map((column: string) => {
          return (
            <Typography
              variant="tableHeader"
              sx={{
                flex: 1,
              }}
              key={column}
            >
              {column}
            </Typography>
          )
        })}
      </Box>

      <div>
        {data.map((obj: any, index: number) => {
          return (
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                marginBottom: 5,
                marginTop: 5,
                gridAutoFlow: "column",
              }}
              key={index}
            >
              {columns.map((column: string, colIndex: number) => {
                return (
                  <Typography
                    sx={{
                      whiteSpace: "pre-wrap",
                      flex: 1,
                      overflow:
                        column == "location" || column === "column_name"
                          ? "scroll"
                          : "inherit",
                    }}
                    variant="viewConfigText"
                    key={colIndex}
                    component={"div"}
                    title={obj[column]}
                  >
                    {column === "model_refresh_start_date" ||
                    column === "model_refresh_end_date"
                      ? new Date(obj[column]).toLocaleDateString()
                      : obj[column]}
                  </Typography>
                )
              })}
            </Box>
          )
        })}
      </div>
    </div>
  )
}
